﻿import type { RouteRecordRaw } from 'vue-router'

const settingsRoutes: RouteRecordRaw = {
  path: '/settings',
  name: 'Settings',
  redirect: '/settings/role',
  meta: { title: '系统设置', icon: 'icon-settings' },
  children: [
    { path: 'role', name: 'SettingsRole', component: () => import('@/views/settings/RoleList.vue'), meta: { title: '角色权限', permissions: ['settings:role:view'] } },
    { path: 'print', name: 'SettingsPrint', component: () => import('@/views/settings/PrintList.vue'), meta: { title: '打印模板', permissions: ['settings:print:view'] } },
    { path: 'number', name: 'SettingsNumber', component: () => import('@/views/settings/NumberList.vue'), meta: { title: '编号规则', permissions: ['settings:number:view'] } },
    { path: 'workflow', name: 'SettingsWorkflow', component: () => import('@/views/settings/WorkflowList.vue'), meta: { title: '审批流程', permissions: ['settings:workflow:view'] } },
    { path: 'params', name: 'SettingsParams', component: () => import('@/views/settings/ParamsList.vue'), meta: { title: '系统参数', permissions: ['settings:params:view'] } },
    { path: 'account-mapping', name: 'SettingsAccountMapping', component: () => import('@/views/settings/AccountMapping.vue'), meta: { title: '科目映射', permissions: ['settings:account:view'] } },
    { path: 'tax-template', name: 'SettingsTaxTemplate', component: () => import('@/views/settings/TaxTemplateList.vue'), meta: { title: '税费模板', permissions: ['settings:tax:view'] } },
  ],
}

export default settingsRoutes
